
  // Progress bar calculation function
  function calculateProgress(currentVal, targetVal = 30000) {
    const progressBar = document.querySelector('.cart-shippingThreshold__progress');
    const progressNum = document.querySelector('.cart-shipping__num');
    const progressOuter = document.querySelector('.cart-shipping__numOuter');
    const successMsg = document.querySelector('.cart-shipping__success');
    
    if (!progressBar) return;
    
    currentVal = parseInt(currentVal);
    const result = Math.min(100, Math.round((currentVal / targetVal) * 100));
    progressBar.style.width = `${result}%`;
    
    const remaining = ((targetVal - currentVal) / 100).toFixed(2);
    
    if (currentVal >= targetVal) {
      if (progressOuter) progressOuter.style.display = 'none';
      if (successMsg) successMsg.style.display = 'block';
    } else {
      if (progressOuter) {
        progressOuter.style.display = 'block';
        if (progressNum) progressNum.textContent = remaining;
      }
      if (successMsg) successMsg.style.display = 'none';
    }
  }

  // Main function to update cart progress
  function updateCartProgress() {
    fetch('/cart.js')
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(cart => {
        calculateProgress(cart.total_price);
      })
      .catch(error => console.error('Error updating cart progress:', error));
  }

  // Initialize progress bar
  function initProgressBar() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && !cartDrawer.classList.contains('is-empty')) {
      updateCartProgress();
    }
  }

  // Enhanced event delegation with retry logic
  function setupEventListeners() {
    // Remove any existing listeners to prevent duplicates
    document.removeEventListener('click', handleCartInteractions);
    document.removeEventListener('change', handleInputChanges);
    
    // Add new listeners
    document.addEventListener('click', handleCartInteractions);
    document.addEventListener('change', handleInputChanges);
  }

  function handleCartInteractions(event) {
    // Handle plus/minus buttons
    if (event.target.closest('.quantity__button')) {
      setTimeout(() => {
        updateCartProgress();
        setupEventListeners(); // Re-setup listeners after DOM changes
      }, 500); // Increased delay to ensure DOM updates
    }
    // Handle remove buttons
    else if (event.target.closest('.cart-remove-button')) {
      setTimeout(() => {
        updateCartProgress();
        setupEventListeners(); // Re-setup listeners after DOM changes
      }, 500); // Increased delay to ensure DOM updates
    }
  }

  function handleInputChanges(event) {
    if (event.target.matches('.quantity__input')) {
      setTimeout(() => {
        updateCartProgress();
        setupEventListeners(); // Re-setup listeners after DOM changes
      }, 500);
    }
  }

  // Standard Shopify events
  document.addEventListener('cart:updated', function() {
    setTimeout(updateCartProgress, 300);
    setupEventListeners();
  });

  document.addEventListener('cart:requestComplete', function() {
    setTimeout(updateCartProgress, 300);
    setupEventListeners();
  });

  // Custom events for cart drawer
  document.addEventListener('cart-drawer:afterOpen', function() {
    initProgressBar();
    setupEventListeners();
  });

  // Mutation observer with enhanced configuration
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0 || mutation.attributeName === 'class') {
        setTimeout(() => {
          updateCartProgress();
          setupEventListeners();
        }, 500);
      }
    });
  });

  // Initialize when page loads
  document.addEventListener('DOMContentLoaded', function() {
    initProgressBar();
    setupEventListeners();
    
    // Observe the entire cart drawer for changes
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  });

  // Additional event listener for AJAX cart updates
  document.addEventListener('ajaxCart:afterUpdate', function() {
    setTimeout(updateCartProgress, 300);
    setupEventListeners();
  });
